import React, { Component } from "react"
import TableAditivosTrash from "./TableAditivosTrash"
import Layout from "../../Layout"
import { Loading } from "../../../components"
import * as ApiHelper from "../../../ApiHelper"
export default class AditivosTrash extends Component {
  constructor() {
    super()
    this.getAditivos = this.getAditivos.bind(this)
    this.filter = this.filter.bind(this)
    this.state = {
      aditivos: [],
      initialAditivos: [],
      showTable: false,
      currentPage: 1,
      pageCount: ""
    }
  }
  componentWillMount() {
    this.getAditivos(this.state.currentPage)
  }
  getAditivos(page) {
    ApiHelper.getAditivosTrash(page, (aditivos, error) => {
      if (aditivos) {
        this.setState({
          aditivos: aditivos.data,
          initialAditivos: aditivos.data,
          showTable: true,
          pageCount: aditivos.last_page
        })
      } else {
        console.log(error)
      }
    })
  }
  filter(event) {
    var searchText = event.target.value.toLowerCase()
    var filtered = this.state.initialAditivos.filter(aditivo => {
      return (
        aditivo.objeto.toLowerCase().search(searchText) !== -1 ||
        aditivo.num_contrato.toLowerCase().search(searchText) !== -1
      )
    })
    this.setState({
      aditivos: filtered
    })
  }
  handlePageChange(data) {
    window.scrollTo(0, 0)
    this.getAditivos(data.selected + 1)
  }
  render() {
    return (
      <Layout tabActive="Contratos">
        {this.state.showTable ? (
          <TableAditivosTrash
            pageCount={this.state.pageCount}
            handlePageClick={this.handlePageChange}
            filter={this.filter}
            onRestore={this.getAditivos}
            sizeClass=""
            title="Aditivos deletados"
            subtitle="Listagem de todos os aditivos deletados"
            backgroundColor="as-blue"
            rows={this.state.aditivos}
          />
        ) : (
          <Loading />
        )}
      </Layout>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/contratos/aditivos/AditivosTrash.js